<div class="ra-radio-container">
    <label>
        <input type="radio" [name]="radioName" [attr.name]="radioName" value="departure" [(ngModel)]="filterValue.timeType" />
        Departure
    </label>
    <label>
        <input type="radio" [name]="radioName" [attr.name]="radioName" value="arrival" [(ngModel)]="filterValue.timeType" />
        Arrival
    </label>
</div>
<div class="ra-time-container">
    <kendo-timepicker [(value)]="filterValue.startTime"></kendo-timepicker>
    <kendo-timepicker [(value)]="filterValue.endTime"></kendo-timepicker>
</div>
